module.exports = __webpack_public_path__ + "img/gf2sat.50e0590a.png";